import { faBell } from '@fortawesome/pro-light-svg-icons'

import { GrowpIcon } from 'packages/components/GrowpIcon'
import { $t } from 'packages/locale'
import { PermEnum } from 'packages/sdks-next/growp'
import { MenuItemUnion } from 'packages/web-layout/types'

/**
 * 资讯管理 menu 定义
 *
 * @returns menus
 */
export const useHotNewsAdminMenu: () => MenuItemUnion[] = () => {
  return [
    {
      path: '/admin/hot-news',
      label: (
        <GrowpIcon
          name="User"
          text={$t('资讯管理')}
          size={14}
          textMarginLeft={16}
        />
      ),
      height: 40,
      perm: PermEnum.Information,
    },
  ]
}
